import { fork } from 'redux-saga/effects';

import { actions } from 'domain/smcTag';
import { itemNavigator } from 'sagas/common';
import { combinedFields } from './index';

export default function* navigator(args) {
  yield fork(itemNavigator, { modelName: 'Smctag', actions, editableFields: combinedFields }, args);
}
